export const PRODUCTPRICETYPE_SHOW_RESET = 'PRODUCTPRICETYPE_SHOW_RESET'
export const PRODUCTPRICETYPE_SHOW_SET_ERROR = 'PRODUCTPRICETYPE_SHOW_SET_ERROR'
export const PRODUCTPRICETYPE_SHOW_SET_RETRIEVED = 'PRODUCTPRICETYPE_SHOW_SET_RETRIEVED'
export const PRODUCTPRICETYPE_SHOW_TOGGLE_LOADING = 'PRODUCTPRICETYPE_SHOW_TOGGLE_LOADING'
